
import { Station } from "@/api/dtos/Station.schema";
import EditFrame from "@/components/EditFrame.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

interface ExclusiveRentalPublicSettingsPayload {
  visible: boolean;
  text: string | null;
}

@Component({
  components: {
    EditFrame
  }
})
export default class ExclusiveRentalPublicSettings extends Vue {
  @Prop()
  station!: Station;

  @Prop({
    default: false
  })
  creationMode!: boolean;

  localVisible = false;
  localText: string | null = null;
  private initialized = false;

  get normalizedText (): string | null {
    if (this.localText == null) return null;
    const trimmed = this.localText.trim();
    return trimmed === "" ? null : trimmed;
  }

  get stationVisible (): boolean {
    return this.station.exclusiveRentalPublicVisible ?? false;
  }

  get stationText (): string | null {
    return this.station.exclusiveRentalPublicText ?? null;
  }

  get hasChanges (): boolean {
    return (
      this.localVisible !== this.stationVisible ||
      this.normalizedText !== this.stationText
    );
  }

  @Watch("station", { immediate: true, deep: true })
  onStationChanged (): void {
    if (this.initialized && !this.creationMode && this.hasChanges) return;
    this.resetLocalChanges();
    this.initialized = true;
  }

  @Watch("localVisible")
  @Watch("localText")
  onLocalSettingsChanged (): void {
    if (this.creationMode) {
      this.emitSave();
    }
  }

  resetLocalChanges (): void {
    this.localVisible = this.stationVisible;
    this.localText = this.stationText;
  }

  save (): void {
    this.emitSave();
  }

  private emitSave (): void {
    const payload: ExclusiveRentalPublicSettingsPayload = {
      visible: this.localVisible,
      text: this.normalizedText
    };
    this.$emit("save", payload);
  }
}
